/* ======================================================
   Logos
   Map a name (exactly as it appears in questions.js or on the
   slides) to either:
     - a website domain → its icon is loaded from Google's favicon service
     - a full https:// URL to a logo image
   Anything missing, or any image that fails to load, falls back to
   the name on its own.
====================================================== */

const logos = {
  // Accounting systems
  Workday: 'workday.com',
  NetSuite: 'netsuite.com',
  MYOB: 'myob.com',
  Xero: 'xero.com',
  SAP: 'sap.com',
  Oracle: 'oracle.com',
  'Microsoft Dynamics 365': 'dynamics.microsoft.com',
  TechnologyOne: 'technologyonecorp.com',
  'Sage Intacct': 'sage.com',

  // Reporting & planning
  Excel: 'microsoft.com',
  'Power BI': 'powerbi.microsoft.com',
  Tableau: 'tableau.com',
  'Workday Adaptive Planning': 'workday.com',
  Anaplan: 'anaplan.com',

  // Workplace & AI
  'Microsoft 365': 'microsoft.com',
  'Google Workspace': 'workspace.google.com',
  Claude: 'claude.ai',
  'ChatGPT / OpenAI': 'openai.com',
  'Microsoft Copilot': 'copilot.microsoft.com',
  'Google Gemini': 'gemini.google.com',
  OpenRouter: 'openrouter.ai',

  // Clients and organisations
  NobleOak: 'nobleoak.com.au',
  'Shift Financial': 'shift.com.au',
  'The University of Sydney': 'sydney.edu.au',
  'Western Sydney University': 'westernsydney.edu.au',
};

export default logos;
